import { MODEL_FIELDS } from './createRequest.model';
import moment from 'moment';

export const DATA_GENERATOR_CONFIG = [
  { name: MODEL_FIELDS.firstName, type: 'text' },
  { name: MODEL_FIELDS.lastName, type: 'text' },
  { name: MODEL_FIELDS.address, type: 'text', minLength: 4, maxLength: 40 },
  { name: MODEL_FIELDS.postcode, type: 'text' },
  { name: MODEL_FIELDS.city, type: 'text' },
  {
    name: MODEL_FIELDS.refuseDebitsAndDepositsPartnerDeadline,
    type: 'date',
    min: moment().add(6, 'weeks').toDate(),
  },

  {
    name: MODEL_FIELDS.birthday,
    type: 'date',
    max: '1980-09-14T13:32:10.405+00:00',
  },
  { name: MODEL_FIELDS.oldIban, type: 'text', validate: 'iban' },
  { name: MODEL_FIELDS.newIban, type: 'text', validate: 'iban' },
];
